import { Button } from '@/components/ui/button'
import { ArrowBigLeftIcon } from 'lucide-react'

export function NotFound({
  message,
  title,
  actionCallback,
}: {
  message?: string | React.ReactNode
  title?: string
  actionCallback?: () => void
}) {
  return (
    <div className="absolute w-full h-full flex flex-col justify-center items-center">
      <div className="vstack">
        <h1 className="font-mono font-extrabold text-3xl">
          {title || 'Not Found'}
        </h1>
        <Button
          size="lg"
          onClick={(e) => {
            if (typeof actionCallback === 'function') {
              actionCallback()
            } else {
              e.preventDefault()
              window.history.back()
            }
          }}
        >
          <ArrowBigLeftIcon className="w-6 h-6" />
        </Button>
        {message && <p className="text-center py-2">{message}</p>}
      </div>
    </div>
  )
}
